import { render, staticRenderFns } from "./ActionRequiredHeader.vue?vue&type=template&id=cf4a1eea&"
import script from "./ActionRequiredHeader.vue?vue&type=script&lang=ts&"
export * from "./ActionRequiredHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ActionRequiredHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports